export default __webpack_public_path__ + "static/media/P60.fc85ae2b.png";